import { Vue, BitrixVue } from 'ui.vue';
import { MessageBox } from 'ui.dialogs.messagebox';
import './style.css'
import '../../sku_progress_bar/src/script';
import '../../sku_settings_bar/src/script';
Vue.component('vue-product-input', {
    data() {
        return {
            count: 0,
            MAX_QUANTITY: 10000,
            MAX_PRICE: 1000000,
            quantityChanged: false,
            delayedQuantityChange: null,
            delayedQuantityTriggerTime: 500,
            oldInputQuantity: null
        };
    },
    props: {
        productId: {
            type: Number,
            required: true
        },
        productAnalog: {
            type: String
        },
        showNotes: {
            type: Boolean,
            default: false
        },
        showClear: {
            type: Boolean,
            default: true
        },
        showAtantion: {
            type: Boolean,
            default: false
        },
        showCanbuy: {
            type: Boolean,
            default: true
        },
    },
    computed: {
        index: (state) => {
            return state.catalogProduct?.ID;
        },
        localize() {
            return BX.Vue.getFilteredPhrases("");
        },
        basketProduct: (state) => {
            return state.$store.hasModule("basket") ? state.$store.getters['basket/findItem'](state.$props.productId) : null;
        },
        basketProductProps: (state) => {
            return state.basketProduct && state.basketProduct.PROPS ? state.basketProduct.PROPS : {};
        },
        catalogProduct: (state) => {
            return state.$store.getters['catalog/findItem'](state.$props.productId);
        },
        catalogProductXML_ID: (state) => {
            return state.catalogProduct?.XML_ID?.replace(/(.)*#/i, '')
        },
        isAnalog: (state) => {
            return state.$props.productAnalog == 'Y';
        },
        titleDel: (state) => {
            return state.localize.DEL_PRODUCT ? state.localize.DEL_PRODUCT?.replace("#PRODUCT#", state.catalogProduct.NAME) : '';
        },
        titleAdd: (state) => {
            return state.localize.ADD_PRODUCT ? state.localize.ADD_PRODUCT?.replace("#PRODUCT#", state.catalogProduct.NAME) : '';
        },
        inputTitle: (state) => {
            let title = state.localize.PRODUCT_IN_BASKET_BASKETID_QUANTITY_NAME;
            if (state.$store.getters['basket/basket'] != undefined && state.$store.getters.basket.ACCOUNT_NUMBER != undefined) {
                title = title?.replace("#BASKETID#", state.$store.getters.basket.ACCOUNT_NUMBER);
            } else {
                title = title?.replace("#BASKETID#", "");
            }
            /* if (this.basketProduct) {
                title = title.replace("#NAME#", this.basketProduct.NAME);
                title = title.replace("#QUANTITY#", this.catalogProduct.QUANTITY);
            } else  */
            if (state.catalogProduct) {
                title = title?.replace("#NAME#", state.catalogProduct.NAME);
                title = title?.replace("#QUANTITY#", state.oldInputQuantity || state.catalogProduct.QUANTITY);
            }
            return title;
        },
        inputConfirmQuestion: (state) => {
            return state.localize.INPUT_MORE_THEN?.replace("#PRODUCT#", state.catalogProduct.NAME);
        },
        inputQuantity: {
            get() {
                return this.catalogProduct.QUANTITY ? parseFloat(this.catalogProduct.QUANTITY) : null;
            },
            set(value) {
                let productPriceSum = (parseFloat(value) * parseFloat(this.catalogProduct.PRICE));
                let productPriceSumCurrency = BX?.Currency?.currencyFormat(productPriceSum, this.$store.getters['basket/getCurrency'], true).replace(/&nbsp;/g, ' ');
                let curProductPriceSum = (parseFloat(this.catalogProduct.QUANTITY) * parseFloat(this.catalogProduct.PRICE));
                if (/* (value > this.MAX_QUANTITY && this.catalogProduct.QUANTITY <= this.MAX_QUANTITY
                        && !confirm(this.inputConfirmQuestion?.replace("#VALUE#", value)?.replace("#PRICE_SUM#", productPriceSumCurrency))
                    ) ||  */
                    (productPriceSum > this.MAX_PRICE && curProductPriceSum <= this.MAX_PRICE
                        // && !confirm(this.inputConfirmQuestion?.replace("#VALUE#", value)?.replace("#PRICE_SUM#", productPriceSumCurrency))
                    )) {
                    BX.UI.Dialogs.MessageBox.confirm(
                        this.inputConfirmQuestion?.replace("#VALUE#", value)?.replace("#PRICE_SUM#", productPriceSumCurrency),
                        this.localize.VUE_INPUT_MORE_TITLE,
                        BX.proxy(() => {
                            if (this.catalogProduct.QUANTITY != value) this.quantityChanged = true;
                            this.catalogProduct.QUANTITY = value;
                            return true;
                        }),
                        "OK",
                        BX.proxy(() => {
                            return true;
                        }),
                    );
                } else {
                    if (this.catalogProduct.QUANTITY != value) this.quantityChanged = true;
                    this.catalogProduct.QUANTITY = value;
                }
            }
        }
    },
    mounted() {
        this.oldInputQuantity = this.inputQuantity;
        if (this.isAnalog) {
            BX.addCustomEvent('OnAnalogWindowAccept', this.sendAnalog);
            BX.addCustomEvent('OnAnalogWindowClose', this.clearAnalog);
        }
        let searchXML_ID;
        if (searchXML_ID = (new URL(location.href))?.searchParams?.get("q")) {
            if (this.catalogProductXML_ID === searchXML_ID) {
                this.focusInput();
            }
        }
    },
    beforeDestroy() {
        debugger;
    },
    methods: {
        sendAnalog: function (event) {
            if (this.isAnalog && this.oldInputQuantity != this.inputQuantity) {
                let quantity = null;
                // В окне аналогов изменилось количество inputQuantity на другое
                if (this.inputQuantity !== null
                    && this.oldInputQuantity !== this.inputQuantity
                ) {
                    quantity = this.inputQuantity;
                    this.catalogProduct.SEND2BASKET = true;
                    this.$store.dispatch('catalog/changeQuantity', { item: this.catalogProduct, quantity: quantity }).then((result) => {
                        if (this.basketProduct.ID) {
                            this.$store.commit('basket/setProductProperty', {
                                ID: this.basketProduct.ID,
                                PROPS: {
                                    ANALOG: {
                                        NAME: 'ANALOG',
                                        CODE: 'ANALOG',
                                        VALUE: 'Y'
                                    }
                                }
                            });
                        } else {
                            console.error("No product in basket before add property");
                        }
                    });
                } else
                    // В окне аналогов изменилось количество inputQuantity 0 или NULL - удалить товар без добавления свойства
                    if (this.inputQuantity == null && this.oldInputQuantity !== null) {
                        quantity = 0;
                        this.catalogProduct.SEND2BASKET = true;
                        this.$store.dispatch('catalog/changeQuantity', { item: this.catalogProduct, quantity: quantity }).then((result) => {
                            //
                        });
                    }
                this.oldInputQuantity = null;
                this.catalogProduct.CAN_BUY_IN_PERCENT = null; // TODO временно, разобраться как иначе обнулять прогрессбар
            }
        },
        clearAnalog: function (event) {
            if (this.isAnalog
                && this.oldInputQuantity !== null
                && this.oldInputQuantity !== this.inputQuantity
            ) {
                this.basketProductProps.ANALOG = null;
                this.catalogProduct.SEND2BASKET = false;
                this.$store.dispatch('catalog/changeQuantity', { item: this.catalogProduct, quantity: this.oldInputQuantity }).then((result) => {
                    //
                });
                this.oldInputQuantity = null;
                this.catalogProduct.CAN_BUY_IN_PERCENT = null; // TODO убрать
            }
        },
        productQuantityChange: function (event) {
            clearTimeout(this.delayedQuantityChange);
            if (this.catalogProduct && this.quantityChanged) {
                if (this.isAnalog) {
                    this.catalogProduct.SEND2BASKET = false;
                } else {
                    if (this.inputQuantity < 0 || this.inputQuantity == undefined)
                        this.inputQuantity = 0;
                    this.catalogProduct.SEND2BASKET = true;
                }
                this.$store.dispatch('catalog/changeQuantity', { item: this.catalogProduct, quantity: this.inputQuantity }).then((result) => {
                    //
                });
            }
            this.quantityChanged = false;
        },
        quantityDown: function (event) {
            if (this.inputQuantity > 0) this.inputQuantity -= 1;
            if (this.inputQuantity <= 0) this.inputQuantity = 0;
        },
        quantityUp: function (event) {
            if (!this.inputQuantity) this.inputQuantity = 0;
            if (this.inputQuantity >= 0) this.inputQuantity += 1;
        },
        inputQuantityUp: function (event) {
            clearTimeout(this.delayedQuantityChange);
            this.delayedQuantityChange = setTimeout(() => {
                this.productQuantityChange(event)
            }, this.delayedQuantityTriggerTime);
        },
        changeInput: function (event) {
            if (event.keyCode == 13 || event.keyCode == 40 || event.keyCode == 38) {
                if (event.keyCode == 40 || event.keyCode == 38) event.preventDefault();
                let nextInput,
                    $inputs = document.querySelectorAll("input.product-item-amount-field");
                if (event.shiftKey == true || event.keyCode == 38) {
                    nextInput = $inputs[[].indexOf.call($inputs, event.target) - 1];
                } else {
                    nextInput = $inputs[[].indexOf.call($inputs, event.target) + 1];
                }
                if ($inputs.length && nextInput) {
                    if (!isMobile.any()) {
                        nextInput.focus();
                        nextInput.select();
                    }
                } else {
                    this.productQuantityChange(event);
                }
            }
        },
        focusInput: function (event) {
            this.$refs.productQuantity?.scrollIntoView({ block: "center", behavior: "smooth" });
            this.$refs.productQuantity?.focus();
        }
    },
    template: `
            <div v-if="catalogProduct != undefined" class="vue-product-input-init">
                <div class="product-item-amount">
                    <span class="product-item-amount-field-btn-minus no-select"
                        @click.stop="quantityDown"
                        @mouseup.passive="inputQuantityUp"
                        @mouseout.passive="productQuantityChange"
                        :disabled="!parseInt(catalogProduct.QUANTITY)"
                        :title="titleDel"
                        :id="'minus_'+productId"></span>
                    <div class="product-item-amount-field-wrap">
                        <input autocomplete="off" pattern="\d*"
                            :min="0"
                            max="1000000"
                            step="1"
                            type="number"
                            placeholder="0"
                            :tabindex="index"
                            :data-product_id="productId"
                            :name="productId"
                            :data-inputquantity-offer-id="productId"
                            :data-offer-num="productId"
                            :data-addtobasket-action="isAnalog"
                            :id="'QUANTITY_'+productId"
                            class="product-item-amount-field basket-input"
                            style="color:#000"
                            :title="inputTitle"
                            ref="productQuantity"
                            @paste="productQuantityChange"
                            @keydown.stop="changeInput"
                            @keyup.stop="inputQuantityUp"
                            @blur.passive="productQuantityChange"
                            v-model.number="inputQuantity"
                            :aria-label="inputTitle"
                        >
                        <span
                            v-if="catalogProduct.MEASURE_NAME && false"
                            class="product-item-amount-description-container"
                            >
                            <span :id="'QUANTITY_MEASURE_'+productId">{{catalogProduct.MEASURE_NAME}}</span>
                            <span :id="'PRICE_TOTAL_ID_'+productId"></span>
                        </span>
                        <vue-product-quantity-progress-bar v-if="catalogProduct" :product-id="productId"/>
                    </div>
                    <span class="product-item-amount-field-btn-plus no-select"
                        @click.stop="quantityUp"
                        @mouseup.passive="inputQuantityUp"
                        @mouseout.passive="productQuantityChange"
                        :title="titleAdd"
                        :id="'plus_'+productId"></span>
                </div>
                <vue-product-quantity-settings-bar
                    v-if="catalogProduct"
                    :show-notes="showNotes"
                    :show-clear="showClear"
                    :show-atantion="showAtantion"
                    :show-canbuy="showCanbuy"
                    :product-id="productId"
                    :product-analog="isAnalog?'Y':''"
                    />
            </div>`
});
